import React from "react";

// Need to do this as workaroudn known issue, https://github.com/akiran/react-slick/issues/1130
export const SlickButtonFix = (props: {
  children: React.ReactNode;
  slideCount?: number;
  currentSlide?: number;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { children, currentSlide, slideCount, ...others } = props;
  return <span {...others}>{children}</span>;
};
